/* eslint-disable linebreak-style */
// Dev
// const appIdKey = [
//   '5d12644e-8216-89dc-4fb4-4j7b972320d2',
//   '3d429141-5e52-4593-8d8e-74954ca8317a',
//   '95db62f8-b80d-443a-b4ee-149d698c703c',
// ];
// Prod
const appIdKey = ['5d12644e-8216-4fb4-89dc-4e9b972310c4'];
// Demo
// const appIdKey = ['5d12644e-8216-89dc-4fb4-4j7b972320d2'];

export { appIdKey };
